import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useApprovalsController } from 'api/controllers/ApprovalsController';

import { ApprovalRuleCreate, ApprovalRule } from 'openapi';

import { AppRoutesEnum } from 'utils/routes';

import { ApprovalRuleForm } from './ApprovalRuleForm';

export const CreateApprovalRule = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const { createApprovalRuleForCompany, getAllApprovalRulesForCompany } =
    useApprovalsController();

  const [existingRules, setExistingRules] = useState<ApprovalRule[]>([]);

  useEffect(() => {
    const fetchExistingRules = async () => {
      if (!companyId) return;

      try {
        const data = await getAllApprovalRulesForCompany(Number(companyId));
        setExistingRules(data?.rules ?? []);
      } catch (error) {
        console.error('Failed to fetch existing approval rules:', error);
      }
    };

    fetchExistingRules();
  }, [companyId, getAllApprovalRulesForCompany]);

  const handleBack = () => {
    if (!companyId) return;
    navigate(
      AppRoutesEnum.COMPANY_APPROVAL_RULES.replace(':companyId', companyId)
    );
  };

  const handleSave = async (values: ApprovalRuleCreate) => {
    if (!companyId) return;

    try {
      await createApprovalRuleForCompany(Number(companyId), values);
      navigate(
        AppRoutesEnum.COMPANY_APPROVAL_RULES.replace(':companyId', companyId)
      );
    } catch (err) {
      console.error('Error creating approval rule:', err);
    }
  };

  return companyId ? (
    <ApprovalRuleForm
      onSave={handleSave}
      onCancel={handleBack}
      companyId={Number(companyId)}
      existingRules={existingRules}
    />
  ) : null;
};
